<template>
  <div class="sports-header-wrap">
		<div class="sports-header">
			<div v-for="sport in metaData.sports"
				:key="'header-sport-' + sport.id"
				:class="{active: sport.id === selectedSport.id}"
        class="sport-item"
				@click="selectSport(sport)">

				<div class="icon-container">
					<div class="icon-wrapper">
						<i :class="'icon n-i-live-' + sport.providerId"></i>
					</div>
				</div>
				<div class="sport-name">
					{{sport.name}}
				</div>
			</div>
		</div>
		<div class="datepicker-wrap">
      <div v-if="platform === 'Terminal'">
        <DatepickerTouchPopup :show="datepickerPopup.show"
            :dateLabel="datepickerPopup.dateLabel"
            :headerLabel="datepickerPopup.headerLabel"
            :monthLabel="datepickerPopup.monthLabel"
            :dayLabel="datepickerPopup.dayLabel"
            :yearLabel="datepickerPopup.yearLabel"
            :saveLabel="datepickerPopup.saveLabel"
            :cancelLabel="datepickerPopup.cancelLabel"
            @closePopup="closeDatepicker()"
            @change="setDate($event); getResults()">
        </DatepickerTouchPopup>
      </div>
			<datepicker v-else
        v-model="datepicker"
        v-on:input="getResults()"
        :bootstrap-stying="true"
        class="datepicker"></datepicker>
		</div>
    <div :class="'sport-header sport-header-' + selectedSport.providerId">
				{{selectedSport.name}}
			</div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { mapState } from 'vuex';
import DatepickerTouchPopup from '@nsftx/nsoft-components/src/components/DatepickerTouchPopup.vue';
import config from '../config';
import { toUTC } from '../helpers';

export default {
  name: 'resultsHeader',
  components: {
    Datepicker,
    DatepickerTouchPopup,
  },
  computed: mapState([
    'metaData',
    'selectedSport',
  ]),
  methods: {
    closeDatepicker() {
      this.datepickerPopup.show = false;
    },
    setDate(e) {
      this.datepickerPopup.selectedDate = e.date;
    },
  },
  data() {
    return {
      platform: config.delivery_platform,
      datepicker: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
      ),
      datepickerPopup: {
        show: false,
        selectedDate: null,
        dateLabel: this.$store.getters.translate('general_date'),
        headerLabel: this.$store.getters.translate('general_select_date'),
        monthLabel: this.$store.getters.translate('general_month'),
        dayLabel: this.$store.getters.translate('general_day'),
        yearLabel: this.$store.getters.translate('general_year'),
        saveLabel: this.$store.getters.translate('general_save'),
        cancelLabel: this.$store.getters.translate('general_cancel'),
      },
      getResults() {
        let startDate;
        let endDate;

        if (this.datepickerPopup.selectedDate) {
          startDate = new Date(`${this.datepickerPopup.selectedDate} 00:00:00`);
          endDate = new Date(`${this.datepickerPopup.selectedDate} 23:59:59`);
        } else {
          startDate = this.datepicker;
          endDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate(),
            23, 59, 59,
          );
        }

        this.$store.dispatch('FETCH_RESULTS', {
          start_date: toUTC(startDate),
          end_date: toUTC(endDate),
        });
        this.$store.dispatch('SAVE_DATE', startDate);
      },
      selectSport(sport) {
        this.$store.dispatch('SELECT_SPORT', sport);
        this.$store.dispatch('FILTER_SELECTION');
      },
    };
  },
};
</script>

<style lang="scss">
  @import '../scss/themes/themes';
</style>
